const onGet = ( status ) => {

    switch ( status ) {
        case 404:
            localStorage.removeItem('token');
            return {
                status: status,
                message: "l' utente non esiste",
            }    
        case 422:
            return {
                status: status,
                message: "l' uuid utente non è corretto",
            } 
        default:
            return null;
    }

}

export default onGet;